<template>
  <div id="centroNuevo">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex xs12>
          <h4 class="grey--text text--darken-1">
            <v-icon small color="primary">drag_indicator</v-icon> Nuevo Centro de Capacitación
          </h4>
        </v-flex>
      </v-layout>
      <v-card>
        <v-card-title class="headline lighten-3">
          <v-spacer></v-spacer>
          <v-btn color="primary" dark to="/centros/capacitacion">Volver</v-btn>
        </v-card-title>
        <v-card-text>
          <v-form ref="form_centro">
            <v-layout row wrap>
              <v-flex xs12 class="my-0 py-0">
                <v-card-title class="grey lighten-4 py-1 px-1">
                  <h3 class="grey--text text--darken-1">Datos Institucionales</h3>
                </v-card-title>
                <v-divider class="mb-0"></v-divider>
              </v-flex>
              <v-flex xs9 lg9 class="py-0">
                <v-text-field
                  type="text"
                  label="Nombre del CCTP"
                  v-model="centro.institucional.nombre"
                  :rules="[v => !!v || 'El campo es requerido']"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs3 lg3 class="py-0">
                <v-text-field
                  type="text"
                  label="Sigla"
                  v-model="centro.institucional.sigla"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs6 md6 lg3 class="py-0">
                <v-select
                  :items="departamentos"
                  label="Departamento"
                  item-text="lugar"
                  item-value="id"
                  v-model="centro.institucional.departamento_id"
                  @change="getProvincias(centro.institucional.departamento_id)"
                  :rules="[v => !!v || 'Seleccione una opción']"
                  required
                ></v-select>
              </v-flex>
              <v-flex xs6 md6 lg3 class="py-0">
                <v-select
                  :items="provincias"
                  label="Provincia"
                  item-text="lugar"
                  item-value="id"
                  v-model="centro.institucional.provincia_id"
                  @change="getMunicipios(centro.institucional.provincia_id)"
                  :rules="[v => !!v || 'Seleccione una opción']"
                  required
                ></v-select>
              </v-flex>
              <v-flex xs12 md6 lg3 class="py-0">
                <v-select
                  :items="municipios"
                  label="Municipio"
                  item-text="lugar"
                  item-value="id"
                  v-model="centro.institucional.municipio_id"
                  @change="getComunidades(centro.institucional.municipio_id)"
                  :rules="[v => !!v || 'Seleccione una opción']"
                  required
                ></v-select>
              </v-flex>
              <v-flex xs12 md6 lg3 class="py-0">
                <v-select
                  :items="comunidades"
                  label="Comunidad"
                  item-text="lugar"
                  item-value="id"
                  v-model="centro.institucional.comunidad_id"
                  :rules="[v => !!v || 'Seleccione una opción']"
                  required
                ></v-select>
              </v-flex>
              <v-flex xs12 sm7 md9 class="pt-0 pb-1">
                <v-text-field
                  type="text"
                  label="Dirección"
                  v-model="centro.institucional.direccion"
                  :rules="[v => !!v || 'El campo es requerido']"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm5 md3 class="pt-0 pb-1">
                <v-text-field
                  type="text"
                  label="Zona"
                  v-model="centro.institucional.zona"
                  :rules="[v => !!v || 'El campo es requerido']"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm4 class="pt-0 pb-1">
                <v-text-field
                  type="number"
                  label="Teléfono"
                  v-model="centro.institucional.telefono"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm4 class="pt-0 pb-1">
                <v-text-field
                  type="text"
                  label="Correo Electrónico"
                  v-model="centro.institucional.correo"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm4 class="py-0">
                <v-menu
                  v-model="fechaCrea"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="centro.institucional.fecha_creacion"
                      label="Fecha de Creación"
                      append-icon="event"
                      :rules="[v => !!v || 'El campo es requerido']"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="centro.institucional.fecha_creacion" @input="fechaCrea = false"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12 sm12 class="pt-0 pb-1">
                <v-text-field
                  type="text"
                  label="Geolocalización"
                  v-model="centro.institucional.geolocalizacion"
                  append-icon="map"
                  readonly
                  @click="showDialogMap"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex xs12 class="my-0 py-0">
                <v-card-title class="grey lighten-4 py-1 px-1">
                  <h3 class="grey--text text--darken-1">Responsable del Centro de Capacitación (Propietario)</h3>
                </v-card-title>
                <v-divider class="mb-0"></v-divider>
              </v-flex>
              <v-flex xs12 sm6 class="py-0">
                <v-text-field
                  type="text"
                  label="Nombres"
                  v-model.trim="centro.propietario.nombre"
                  :rules="[v => !!v || 'El campo es requerido']"
                  @keypress="isText($event)"
                  class="txt-upper"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 sm3 class="py-0">
                <v-text-field
                  type="text"
                  label="Apellido Paterno"
                  v-model.trim="centro.propietario.paterno"
                  @keypress="isText($event)"
                  class="txt-upper"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 sm3 class="py-0">
                <v-text-field
                  type="text"
                  label="Apellido Materno"
                  v-model.trim="centro.propietario.materno"
                  @keypress="isText($event)"
                  class="txt-upper"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 sm6 md3 class="py-0">
                <v-text-field
                  type="text"
                  label="Cédula de Identidad"
                  v-model.trim="centro.propietario.cedula_identidad"
                  :rules="[v => !!v || 'El campo es requerido', v => (!!v && v.length > 3) || 'Mínimo 4 dígitos']"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs6 sm3 class="py-0">
                <v-text-field
                  type="text"
                  label="Complemento"
                  v-model.trim="centro.propietario.complemento"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 sm3 class="py-0">
                <v-select
                  :items="expedidos"
                  label="Expedido"
                  item-text="sigla"
                  item-value="id"
                  v-model="centro.propietario.expedido"
                  :rules="[v => !!v || 'Seleccione una opción']"
                  required
                ></v-select>
              </v-flex>
              <v-flex xs6 sm3 class="py-0">
                <v-btn
                  flat
                  :loading="loadingSegip"
                  outline
                  type="button"
                  color="primary"
                  @click="validarSegip(centro.propietario)"
                >
                  Validar SEGIP
                </v-btn>
              </v-flex>
              <v-flex xs12 md6 lg6 class="py-0">
                <v-text-field
                  type="text"
                  label="Dirección"
                  v-model.trim="centro.propietario.direccion"
                  :rules="[v => !!v || 'El campo es requerido']"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs6 md3 lg3 class="py-0">
                <v-autocomplete
                  label="País"
                  :items="paises"
                  item-value="id"
                  item-text="pais"
                  v-model="centro.propietario.pais_id"
                  :rules="[v => !!v || 'Seleccione una opción']"
                  required
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6 md3 lg3 class="py-0">
                <v-select
                  :items="departamentos"
                  label="Departamento"
                  item-text="lugar"
                  item-value="id"
                  v-model="centro.propietario.departamento_id"
                  :rules="[v => !!v || 'Seleccione una opción']"
                  required
                ></v-select>
              </v-flex>
              <v-flex xs4 class="py-0">
                <v-menu
                  v-model="fechaNacProp"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="centro.propietario.fecha_nacimiento"
                      label="Fecha de Nacimiento"
                      append-icon="event"
                      :rules="[v => !!v || 'El campo es requerido']"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker locale v-model="centro.propietario.fecha_nacimiento" @input="fechaNacProp = false"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs4 class="py-0">
                <v-select
                  :items="generos"
                  label="Genero"
                  item-text="genero"
                  item-value="id"
                  v-model="centro.propietario.genero_tipo_id"
                  :rules="[v => !!v || 'Seleccione una opción']"
                  required
                ></v-select>
              </v-flex>
              <v-flex xs4 class="py-0">
                <v-select
                  :items="estado_civiles"
                  label="Estado Civil"
                  item-text="estado_civil"
                  item-value="id"
                  v-model="centro.propietario.estadocivil_tipo_id"
                  :rules="[v => !!v || 'Seleccione una opción']"
                  required
                ></v-select>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 class="my-0 py-0">
                <v-card-title class="grey lighten-4 py-0 px-1">
                  <h3 class="grey--text text--darken-1">Curso de Capacitación</h3>
                  <v-spacer></v-spacer>
                  <v-btn flat small outline color="primary" @click="showDialogCurso">Agregar Curso</v-btn>
                </v-card-title>
                <v-divider></v-divider>
              </v-flex>
              <v-flex xs12 class="pt-0">
                <v-data-table
                  :headers="headerCurso"
                  :items="centro.cursos_capacitacion"
                  class="elevation-1"
                  no-data-text="No existen registros"
                  hide-actions
                >
                  <template v-slot:items="props">
                    <td>{{ props.index + 1 }}</td>
                    <td>{{ props.item.curso_nombre }}</td>
                    <td>{{ props.item.carga_horaria }}</td>
                    <td>{{ props.item.tiempo }}</td>
                    <td>
                      <v-btn-toggle>
                        <v-btn
                          v-if="props.item.turno_m"
                          small
                          class="transparent"
                        >
                          Mañana
                        </v-btn>
                        <v-btn
                          v-if="props.item.turno_t"
                          small
                          class="transparent"
                        >
                          Tarde
                        </v-btn>
                        <v-btn
                          v-if="props.item.turno_n"
                          small
                          class="transparent"
                        >
                          Noche
                        </v-btn>
                      </v-btn-toggle>
                    </td>
                    <td>
                      <v-tooltip bottom>
                        <template v-slot:activator="{on}">
                          <v-btn
                            v-on="on"
                            icon
                            dark
                            small
                            color="red"
                            @click="removeCurso(props.index)"
                          >
                            <v-icon small>delete</v-icon>
                          </v-btn>
                        </template>
                        <span>Quitar registro</span>
                      </v-tooltip>
                    </td>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 class="my-0 py-0">
                <v-card-title class="grey lighten-4 py-1 px-1">
                  <h3 class="grey--text text--darken-1">Resolución Ministerial</h3>
                </v-card-title>
                <v-divider class="mb-0"></v-divider>
              </v-flex>
              <v-flex xs6 class="my-0">
                <v-text-field
                  label="Número R.M."
                  v-model.trim="centro.numero_rm"
                  :rules="[v => !!v || 'El campo es requerido']"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 class="my-0">
                <v-menu
                  v-model="fechaRm"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="centro.fecha_rm"
                      label="Fecha R.M."
                      append-icon="event"
                      :rules="[v => !!v || 'El campo es requerido']"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="centro.fecha_rm" @input="fechaRm = false"></v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>
          </v-form>
          <div class="text-xs-center mt-3">
            <v-btn color="primary" dark @click="confirmCentro">Guardar</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-container>
    <v-dialog v-model="dialogCurso" scrollable :width="(size_width>1024?'60%':'100%')">
      <v-card>
        <v-card-title class="headline grey lighten-3">
          <span class="headline">Agregar Curso</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-lg fluid class="py-1">
            <v-form ref="form_curso">
              <v-layout row wrap>
                <v-flex xs12 sm6 class="py-0">
                  <v-autocomplete
                    :items="cursos"
                    label="Curso"
                    item-text="curso"
                    item-value="id"
                    v-model="curso.curso_capacitacion"
                    :rules="[v => !!v || 'Seleccione una opción']"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs6 sm3 class="py-0">
                  <v-text-field
                    type="text"
                    label="Carga Horaria"
                    v-model.trim="curso.carga_horaria"
                    :rules="[v => !!v || 'El campo es requerido', v => (!!v && v > 19) || 'Valor mínimo 20', v => (!!v && v < 301) || 'Valor máximo 300']"
                    @keypress="isNumber($event)"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 sm3 class="py-0">
                  <v-text-field
                    type="text"
                    label="Tiempo (mes)"
                    v-model.trim="curso.tiempo"
                    :rules="[v => !!v || 'El campo es requerido', v => (!!v && v > 0) || 'Valor mínimo 1', v => (!!v && v < 5) || 'Valor máximo 4']"
                    @keypress="isNumber($event)"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 class="my-0 pb-0">
                  <h3 class="grey--text text--darken-1">Turno</h3>
                </v-flex>
                <v-flex xs12 sm4 md4 class="py-0">
                  <v-checkbox
                    class="my-0"
                    v-model="curso.turno_m"
                    label="Mañana"
                    hide-details
                  ></v-checkbox>
                </v-flex>
                <v-flex xs12 sm4 md4 class="py-0">
                  <v-checkbox
                    class="my-0"
                    v-model="curso.turno_t"
                    label="Tarde"
                    hide-details
                  ></v-checkbox>
                </v-flex>
                <v-flex xs12 sm4 md4 class="py-0">
                  <v-checkbox
                    class="my-0"
                    v-model="curso.turno_n"
                    label="Noche"
                    hide-details
                  ></v-checkbox>
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success darken-1" flat @click="agregarCurso">
            Agregar
          </v-btn>
          <v-btn color="blue darken-1" flat @click="dialogCurso = false">
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogMap" persistent :width="(size_width>1024?'51%':'90%')">
      <v-card>
        <v-card-title class="headline grey lighten-3">
          <span class="headline">Geolocalización</span>
        </v-card-title>
        <v-card-text class="text-xs-center">
          <p class="grey--text text--darken-2">Marque la ubicación del Centro de Capacitación Técnica Privado.</p>
          <div id="geomap" style="width: 100% !important; height: 50vh"></div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="dialogMap = false">
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="mconfirm" width="300">
      <v-card>
        <v-card-title class="headline grey lighten-3" primary-title>
          <span class="headline">Alerta</span>
        </v-card-title>
        <v-card-text class="text-xs-center">
          {{ mensaje }}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :loading="loadingBtnSend" v-if="hide_accept" color="success darken-1" flat @click="createCentro">
            Aceptar
          </v-btn>
          <v-btn color="blue darken-1" flat @click="mconfirm = false">
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snack.state"
      top
      right
      :timeout="2500"
      :color="snack.color"
      :multi-line="snack.mode === 'multi-line'"
    >
      {{ snack.text }}
    </v-snackbar>
  </div>
</template>
<script>
/* eslint-disable no-console */
import Service from "../services/general";
import axios from "axios";
export default {
  name: "centro-nuevo",
  data() {
    return {
      headers: [
        { text: "Nro", align: "left", sortable: false },
        { text: "Nombres y Apellidos ", value: "nombre" },
        { text: "Cargo ", value: "cargo" },
        { text: "Formación Profesional ", value: "formacion_profesional" },
        { text: "Tipo de Contrato ", value: "tipo_contrato" },
        { text: "Estado ", value: "es_vigente" },
        { text: "Acciones", sortable: false, width: "140px" }
      ],
      headerCurso: Service.headerTable().curso,
      fechaRm: false,
      loading: false,
      color_txt: '',
      hide_accept: true,
      loadingSegip: false,
      loadingBtnSend: false,
      fechaCrea: false,
      fechaNacPrs: false,
      fechaNacProp: false,
      paises: [],
      departamentos: [],
      expedidos: [],
      provincias: [],
      municipios: [],
      comunidades: [],
      cursos: [],
      centro: {
        numero_rm: '',
        fecha_rm: '',
        institucional: {
          sede_central: true,
          nombre: '',
          sigla: '',
          departamento_id: '',
          departamento_nombre: '',
          provincia_id: '',
          provincia_nombre: '',
          municipio_id: '',
          comunidad_id: '',
          direccion: '',
          zona: '',
          calle: '',
          telefono: '',
          correo: '',
          geolocalizacion: ''
        },
        propietario: {
          nombre: '',
          paterno: '',
          materno: '',
          cedula_identidad: '',
          complemento: '',
          expedido: '',
          genero_tipo_id: '',
          estadocivil_tipo_id: '',
          fecha_nacimiento: '',
          pais_id: '',
          departamento_id: '',
          direccion: '',
          segip_id: ''
        },
        cursos_capacitacion: [],
      },
      curso: {
        curso_nombre: '',
        curso_capacitacion: '',
        carga_horaria: '',
        tiempo: '',
        turno_m: false,
        turno_t: false,
        turno_n: false
      },
      generos: [],
      estado_civiles: [],
      dialogCurso: false,
      dialogMap: false,
      mconfirm: false,
      size_width: 0,
      mensaje: '',
      dparams: {},
      map: null,
      snack: {
        state: false,
        color: 'success',
        mode: '',
        text: ''
      }
    };
  },
  mounted() {
    this.dparams = Service.getParams();
    if (this.dparams && this.dparams.roluser != Service.rol().nacional) {
      this.$router.push({name: 'principal'});
    }
    if (this.dparams != null) {
      this.getPaises();
      this.getDepartamentos(1);
      this.getExpedidos(1);
      this.getGeneroEstadoCivil();
    }
    let self = this;
    var lmarker, cmarker;
    this.map = new mapboxgl.Map({
      container: 'geomap',
      style: 'mapbox://styles/mapbox/streets-v11',
      center: [-63.588654, -16.290154], 
      zoom: 4
    });
    this.map.addControl(new MapboxGeocoder({
      accessToken: mapboxgl.accessToken,
      mapboxgl: mapboxgl,
      countries: 'bo',
      placeholder: 'Buscar lugar',
      zoom: 11
    }));
    this.map.addControl(new mapboxgl.NavigationControl());
    this.map.doubleClickZoom.disable();
    this.map.on('click', ev => {
      if (lmarker)
        lmarker.remove();
      cmarker = new mapboxgl.Marker()
      .setLngLat([ev.lngLat.lng, ev.lngLat.lat])
      .addTo(this.map);
      self.centro.institucional.geolocalizacion = JSON.stringify([ev.lngLat.lng, ev.lngLat.lat]);
      lmarker = cmarker;
    });
    this.$nextTick(() => {
      window.addEventListener("resize", this.getWidth);
      this.getWidth();
    });
  },
  methods: {
    getWidth() {
      this.size_width = document.documentElement.clientWidth;
    },
    getPaises() {
      Service.paises().then(response => {
        this.paises = response.data;
      }).catch(error => {
        console.error('Error al cargar datos', error);
      });
    },
    getExpedidos(pais_id) {
      Service.expedidos(pais_id).then(response => {
        this.expedidos = response.data;
      }).catch(error => {
        console.error('Error al cargar datos', error);
      });
    },
    getDepartamentos(pais_id) {
      Service.lugarTipo(Service.nivel().departamento, pais_id).then(response => {
        this.departamentos = response.data;
      }).catch(error => {
        console.error('Error al cargar datos', error);
      });
    },
    getProvincias(departamento_id) {
      Service.lugarTipo(Service.nivel().provincia, departamento_id).then(response => {
        this.provincias = response.data;
      }).catch(error => {
        console.error('Error al cargar datos', error);
      });
    },
    getMunicipios(provincia_id) {
      Service.lugarTipo(Service.nivel().municipio, provincia_id).then(response => {
        this.municipios = response.data;
      }).catch(error => {
        console.error('Error al cargar datos', error);
      });
    },
    getComunidades(municipio_id) {
      Service.lugarTipo(Service.nivel().comunidad, municipio_id).then(response => {
        this.comunidades = response.data;
      }).catch(error => {
        console.error('Error al cargar datos', error);
      });
    },
    getGeneroEstadoCivil() {
      Service.generoEstadoCivil().then(response => {
        this.generos = response.data.genero;
        this.estado_civiles = response.data.estado_civil;
      }).catch(error => {
        console.error('Error al cargar datos', error);
      });
    },
    getCursosFacilitadores() {
      Service.cursosFacilitadores(this.dparams.ie_id).then(response => {
        this.cursos = response.data.cursos;
        this.facilitadores = response.data.facilitadores;
      }).catch(error => {
        console.error('Error al cargar datos', error);
      });
    },
    showDialogCurso() {
      this.$refs.form_curso.reset();
      this.getCursosFacilitadores();
      this.dialogCurso = true;
    },
    agregarCurso() {
      if ((this.curso.turno_m == undefined || this.curso.turno_m == false) && (this.curso.turno_t == undefined || this.curso.turno_t == false) && (this.curso.turno_n == undefined || this.curso.turno_n == false)) {
        this.toast('warning', 'Marque por lo menos una o todos los turnos.');
      } else {
        if(this.$refs.form_curso.validate()) {
          let curso_id = this.cursos.findIndex(x => x.id === this.curso.curso_capacitacion);
          this.curso.curso_nombre = this.cursos[curso_id].curso;
          this.centro.cursos_capacitacion.push(this.curso);
          this.curso = {
            facilitador_id: '',
            curso_nombre: '',
            curso_capacitacion: '',
            carga_horaria: '',
            tiempo: '',
            turno_m: false,
            turno_t: false,
            turno_n: false,
            eliminar: true
          };
          this.toast('success', 'Curso agregado con éxito.');
          this.dialogCurso = false;
        }
      }
    },
    removeCurso(posicion) {
      this.centro.cursos_capacitacion.splice(posicion, 1);
    },
    confirmCentro() {
      if (this.$refs.form_centro.validate()) {
        this.color_txt = 'grey';
        this.loadingBtnSend = false;
        this.hide_accept = true;
        this.mensaje = '¿Está seguro(a) de registrar al Centro de Capacitación con la información ingresada?';
        this.mconfirm = true;
      } else {
        this.toast('warning', 'Debe completar los datos del formulario.');
      }
    },
    createCentro() {
      this.loadingBtnSend = true;
      axios
        .post(Service.getBase() + "guarda/centro", this.centro, Service.getHeader())
        .then(response => {
          this.loadingBtnSend = false;
          if (response.data.estado == 200) {
            this.$refs.form_centro.reset();
            this.mconfirm = false;
            this.centro.cursos_capacitacion = [];
            this.toast("success", "Registro guardado.");
          } else {
            this.toast("warning", response.data.msg);
          }
        })
        .catch(error => {
          this.loadingBtnSend = false;
          this.color_txt = 'error';
          this.hide_accept = true;
          this.mensaje = "No se pudo registrar.";
          // this.toast("error", "No se pudo guardar");
        });
    },
    confirmEliminado(facilitador_id) {
      this.facilitador.id = facilitador_id;
      this.mconfirm = true;
    },
    deleteFacilitador() {
      axios
        .delete(Service.getBase() + 'elimina/facilitador/' + this.facilitador.id, Service.getHeader())
        .then(() => {
          this.toast('success', 'Registro eliminado.');
          this.mconfirm = false;
          this.getFacilitadores();
        })
        .catch(error => {
          console.error('Error al eliminar', error);
        });
    },
    showDialogMap() {
      this.dialogMap = true;
    },
    validarSegip(persona) {
      if (persona.cedula_identidad!='' && persona.nombre!='' && (persona.paterno!='' || persona.materno!='') && persona.fecha_nacimiento!='') {
        this.loadingSegip = true;
        if (Service.validateSegip()) {
          Service.postValidarSegip(persona).then(response => {
            this.loadingSegip = false;
            if (response.data.valido == 1) {
              persona.segip_id = response.data.valido;
              this.toast('success', response.data.msg);
            } else {
              this.toast('warning', response.data.msg);
            }
          }).catch(error => {
            this.loadingSegip = false;
          });
        }
      } else {
        this.toast('warning', 'Ingrese la información necesaria para validar con SEGIP');
      }
    },
    toast(color, text) {
      this.snack.color = color;
      this.snack.text = text;
      this.snack.state = true;
    },
    beforeDestroy() {
      window.removeEventListener("resize", this.getWidth);
    }
  }
};
</script>